import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from './UserContext';

function HomePage() {
    const navigate = useNavigate();
    const { user } = useUser();

    return (
        <div className="home-page">
            <section className="hero-section">
                <div className="container">
                    <h1>Willkommen zur Firmenbewerbungsplattform</h1>
                    <p className="lead">
                        Diese Plattform ermöglicht es Firmen, sich einfach zu registrieren und den Bewerbungsprozess zu verfolgen.
                        Jede Firma erhält eine persönliche Antwort und kann den Status ihrer Bewerbung jederzeit einsehen.
                    </p>
                </div>
            </section>

            <section className="features-section py-5">
                <div className="container">
                    <h2 className="text-center mb-5">Unsere Leistungen</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <div className="page-card">
                            <h3>📋 Firmenliste</h3>
                            <p>Sehen Sie alle registrierten Firmen und deren aktuellen Status ein.</p>
                            <button 
                                className="btn btn-primary mt-3"
                                onClick={() => navigate('/firmen-list')}
                            >
                                Zur Firmenliste
                            </button>
                        </div>

                        <div className="page-card">
                            <h3>➕ Firma anmelden</h3>
                            <p>Registrieren Sie Ihre Firma für eine persönliche Bewerbung.</p>
                            <button 
                                className="btn btn-primary mt-3"
                                onClick={() => navigate('/firma/register')}
                            >
                                Jetzt anmelden
                            </button>
                        </div>

                        {!user && (
                            <div className="page-card">
                                <h3>🔐 Konto erstellen</h3>
                                <p>Erstellen Sie ein Konto, um auf erweiterte Funktionen zuzugreifen.</p>
                                <div className="flex gap-3 mt-3">
                                    <button 
                                        className="btn btn-primary"
                                        onClick={() => navigate('/register')}
                                    >
                                        Registrieren
                                    </button>
                                    <button 
                                        className="btn btn-outline"
                                        onClick={() => navigate('/login')}
                                    >
                                        Anmelden
                                    </button>
                                </div>
                            </div>
                        )}

                        {user?.rolle === 'ADMIN' && (
                            <div className="page-card bg-yellow-50 border-yellow-200">
                                <h3>👑 Admin Bereich</h3>
                                <p>Verwalten Sie Benutzer, Firmen und Einstellungen.</p>
                                <button 
                                    className="btn btn-warning mt-3"
                                    onClick={() => navigate('/dashboard')}
                                >
                                    Zum Dashboard
                                </button>
                            </div>
                        )}

                        {(user?.rolle === 'ADMIN' || user?.rolle === 'TEACHER') && (
                            <div className="page-card bg-blue-50 border-blue-200">
                                <h3>🔒 Private Firmen</h3>
                                <p>Verwalten Sie Ihre privaten Firmeneinträge.</p>
                                <button 
                                    className="btn btn-primary mt-3"
                                    onClick={() => navigate('/private-firmen')}
                                >
                                    Zu meinen Firmen
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <section className="info-section py-8 text-center">
                <h2 className="text-2xl font-bold mb-4">Wie funktioniert's?</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                    <div className="p-4">
                        <div className="text-4xl mb-3">1️⃣</div>
                        <h3 className="font-semibold mb-2">Firma registrieren</h3>
                        <p className="text-gray-600">Registrieren Sie Ihre Firma mit einigen grundlegenden Informationen.</p>
                    </div>
                    <div className="p-4">
                        <div className="text-4xl mb-3">2️⃣</div>
                        <h3 className="font-semibold mb-2">Bestätigung erhalten</h3>
                        <p className="text-gray-600">Sie erhalten eine E-Mail mit Bestätigungslink und Zugangsdaten.</p>
                    </div>
                    <div className="p-4">
                        <div className="text-4xl mb-3">3️⃣</div>
                        <h3 className="font-semibold mb-2">Status verfolgen</h3>
                        <p className="text-gray-600">Verfolgen Sie den Status Ihrer Bewerbung in Echtzeit.</p>
                    </div>
                    <div className="p-4">
                        <div className="text-4xl mb-3">4️⃣</div>
                        <h3 className="font-semibold mb-2">Kontakt</h3>
                        <p className="text-gray-600">Nach der Freigabe erhalten Sie garantiert eine persönliche Antwort.</p>
                    </div>
                </div>
            </section>

            <section className="contact-info py-8 text-center">
                <h3 className="text-2xl font-bold mb-4">Kontakt</h3>
                <p className="text-gray-600 mb-4">Bei Fragen können Sie mich gerne kontaktieren:</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                    <div className="p-4">
                        <p className="text-gray-600">📧 E-Mail: <a href="mailto:Bichsel6343@outlook.com">Bichsel6343@outlook.com</a></p>
                    </div>
                    <div className="p-4">
                        <p className="text-gray-600">📱 Telefon: <a href="tel:+41123456789">+41 79 913 97 48</a></p>
                    </div>
                </div>
            </section>

            <footer className="footer py-8 text-center">
                <div className="footer-content">
                    <div className="footer-links mt-4">
                        <a href="./Datenschutzerklärung">Datenschutzerklärung</a>
                    </div>
                    <p>&copy; 2025 Jason Bichsel - Firmenbewerbungsplattform</p>
                </div>
            </footer>
        </div>
    );
}

export default HomePage;
